module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-RegularItalic.27e27b9a.woff2";